import { ERROR } from '../constants';
import { getDocumentRuntime, isMetadataKey } from '../backend/runtime';

// Function to set a value in local storage
const setLocalStorageItem = (key, value) => {
  if (typeof key !== 'string' || value === undefined) {
    console.error(ERROR.INVALID_LOCAL_STORAGE_KEY_OR_VALUE);
    return null;
  }

  try {
    if (isMetadataKey(key)) throw new Error('Session metadata can only be saved by profile login.');
    const scopedKey = getDocumentRuntime().storageKey(key);
    localStorage.setItem(scopedKey, JSON.stringify(value));
  } catch (error) {
    console.error('Error setting localStorage item:', error);
  }
};

// Function to get a value from local storage
const getLocalStorageItem = (key) => {
  if (typeof key !== 'string') {
    console.error(ERROR.INVALID_LOCAL_STORAGE_KEY_OR_VALUE);
    return null;
  }

  try {
    const runtime = getDocumentRuntime();
    if (isMetadataKey(key)) return runtime.metadata(key);
    const value = localStorage.getItem(runtime.storageKey(key));
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error('Error getting localStorage item:', error);
    return null;
  }
};

export { setLocalStorageItem, getLocalStorageItem };
